import { render, staticRenderFns } from "./autonomousCommunityInput.vue?vue&type=template&id=8840963a&"
import script from "./autonomousCommunityInput.vue?vue&type=script&lang=js&"
export * from "./autonomousCommunityInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports